/**
 * Client mirror of netlify/functions/_lib/application-tax.ts (1.171) — the
 * bundle cannot import a function lib. tests/application-tax.test.ts fails if
 * the two disagree. See the server copy for the rule and why.
 */

export const SALES_TAX_WARNING =
  'You will be charged sales tax if you do not provide a resale permit number or certificate.';

export interface ApplicationTaxInput {
  taxId: string | null | undefined;
  resalePermitNumber: string | null | undefined;
  hasResaleCertificate: boolean;
  salesTaxAcknowledged: boolean;
}

function digits(s: string): string {
  return s.replace(/\D/g, '');
}

export function applicationTaxError(i: ApplicationTaxInput): string | null {
  const taxId = (i.taxId ?? '').trim();
  if (!taxId) return 'Please enter your Tax ID (EIN).';
  if (digits(taxId).length < 9) return 'Please enter your full 9-digit Tax ID (EIN), e.g. 12-3456789.';
  if (needsSalesTaxAck(i) && !i.salesTaxAcknowledged) {
    return `${SALES_TAX_WARNING} Add your resale permit number, or tick "I understand".`;
  }
  return null;
}

export function needsSalesTaxAck(i: Pick<ApplicationTaxInput, 'resalePermitNumber' | 'hasResaleCertificate'>): boolean {
  return !(i.resalePermitNumber ?? '').trim() && !i.hasResaleCertificate;
}
